export const dateToTimestamp = function (dateToConvert = undefined) {
    let date = Date.now();
    if (dateToConvert) {
        date = new Date(dateToConvert).getTime();
    }

    return Math.floor(date / 1000)
};